import { applyMiddleware, createStore, compose } from 'redux';
import thunk from 'redux-thunk';
import { combineReducers } from 'redux';
import reducers from './services';

export function configureStore(initialState: object, ws) {
  const rootReducer = combineReducers(reducers);

  const isDevelopment = process.env.NODE_ENV === 'development';
  // @ts-ignore
  const browserExtensionCompose = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;

  const composeEnhancers =
    isDevelopment && browserExtensionCompose
      ? browserExtensionCompose
      : compose;

  const store = createStore(
    rootReducer,
    initialState,
    composeEnhancers(applyMiddleware(thunk.withExtraArgument(ws))),
  );

  return store;
}
